import { SAND_CAT } from "../config";

export const getFileData = async (twinTag, version, token) => {
  const response = await fetch(
    `${SAND_CAT}/twinSchema/get?twinTag=${twinTag}&version=${version}`,
    {
      method: "GET",
      headers: {
        DeveloperAuthorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    },
  );

  if (!response.ok) {
    throw new Error("Failed to fetch file data");
  }

  return await response.json();
};

export const getFileList = async token => {
  const response = await fetch(`${SAND_CAT}/twinSchema/list`, {
    method: "GET",
    headers: {
      DeveloperAuthorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    throw new Error("Failed to fetch file list");
  }

  return await response.json();
};

export const deleteSchema = async (twinTag, version, token) => {
  const response = await fetch(`${SAND_CAT}/twinSchema/delete`, {
    method: "POST",
    headers: {
      DeveloperAuthorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ twinTag, version }),
  });

  const responseData = await response.json();

  return response.ok && responseData.success;
};

export const saveDraft = async (meta, script, token) => {
  const response = await fetch(`${SAND_CAT}/twinSchema/draft/save`, {
    method: "POST",
    headers: {
      DeveloperAuthorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ meta: meta, script: script }),
  });

  const responseData = await response.json();

  return response.ok && responseData.success;
};

export const publishDraft = async (twinTag, token) => {
  const response = await fetch(`${SAND_CAT}/twinSchema/publish`, {
    method: "POST",
    headers: {
      DeveloperAuthorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ twinTag }),
  });
  const responseData = await response.json();

  return response.ok && responseData.success;
};

export const enableWidget = async (twinTag, version, token) => {
  const response = await fetch(`${SAND_CAT}/twinSchema/enable`, {
    method: "POST",
    headers: {
      DeveloperAuthorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ twinTag, version }),
  });

  const responseData = await response.json();

  return response.ok && responseData.success;
};

export const disableWidget = async (twinTag, version, token) => {
  const response = await fetch(`${SAND_CAT}/twinSchema/disable`, {
    method: "POST",
    headers: {
      DeveloperAuthorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ twinTag, version }),
  });

  const responseData = await response.json();

  return response.ok && responseData.success;
};
